export const MOCK_COLLECTION_DETAIL = {
  title: 'Explore Aircraft Collection',
  description: 'Discover a hand-picked selection of 3D models that showcase the best in Aircraft.',
  images: [
    { id: '1', url: '/temp_images/aircraft1.webp', alt: 'Aircraft model preview 1' },
    { id: '2', url: '/temp_images/aircraft2.webp', alt: 'Aircraft model preview 2' },
    { id: '3', url: '/temp_images/aircraft3.webp', alt: 'Aircraft model preview 3' },
    { id: '4', url: '/temp_images/aircraft4.webp', alt: 'Aircraft model preview 4' },
  ],
}
